import { render, staticRenderFns } from "./NewIRCLicenseForm.vue?vue&type=template&id=37135ba0&scoped=true"
import script from "./NewIRCLicenseForm.vue?vue&type=script&lang=js"
export * from "./NewIRCLicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37135ba0",
  null
  
)

export default component.exports